'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);
import 'slick-carousel';

/**
 * module
 */
import { hover } from './module/_hover';
import { slider } from './module/_slider';
import { responsive } from './module/_responsive';
import { thumb } from './module/_thumb';
import { animation } from './module/_animation';

/**
 * main
 */
const main = (() => {
    const $disabled = $('.js-disabled');

    /**
     * init
     */
    const init = () => {
        hover.init();
        slider.init();
        responsive.init();
        thumb.init();

        $disabled.on('click', event => {
            event.preventDefault();
        });

        $(function () {   //ロード中はコンテンツの高さをページの高さに合わせる
            var h = $(window).height();
            $('#loader-bg ,#loader').height(h).css('display', 'block');
        });
    };

    /**
     * loaded
     */
    const loaded = () => {
        $('body').addClass('is-loaded');

        $('#loader-bg').fadeOut(900);
        $('#loader').fadeOut(500);
        $('#contents').css('opacity', '1');
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    $('#content .layout-hero, #content #introduction')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        });
});

